import Vue from 'vue'

let base = 'http://service.jinlingholdings.com'; // 金陵正式环境
// let base = 'http://122.112.246.160:9002'; // 金陵环境（备份测试）
// let base = 'http://36.156.144.170:9002'; // 金陵测试环境

export const host =  'service.jinlingholdings.com'
// export const host =  'http://122.112.246.160:9002'
//登录
export const getMenu = params => { return Vue.axios.get(`${base}/Api/news/allNewsInfoCategorys`, {params}).then(res => res); };
export const getContent = params => { return Vue.axios.get(`${base}/Api/news/Param/` + params.igid, {params}).then(res => res); };
export const getNewsList = params => {return Vue.axios.get(`${base}/Api/news/NewsInfos/` + params.igid, {params}).then(res => res); };
export const getNewsDetail = params => {return Vue.axios.get(`${base}/Api/news/NewsInfoDetail/` + params.Id).then(res => res); };
// 获取友链
export const LinkRefModules = params => {return Vue.axios.get(`${base}/Api/SysConf/LinkRefModules`,{params}).then(res => res); };
// 获取友链分组
export const LinkGroupModules = params => {return Vue.axios.get(`${base}/Api/SysConf/LinkGroupModules`,{params}).then(res =>res);};
// 获取所有新闻信息，以排序值，更新日期排序
export const allNewsInfo = params => { return Vue.axios.get(`${base}/Api/news/allNewsInfo`,{params}).then(res =>res);};
// 预览新闻详情
export const PreviewDetail = params => { return Vue.axios.get(`${base}/Api/news/PreviewDetail/`+ params.Id,{params}).then(res => res );};



// WEBPACK FOOTER //
// ./src/api/api.js